module.exports = __webpack_public_path__ + "img/productSatellite_17.9ff8d12c.png";